import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { CreateProviderStudioBody } from "@shared-kernel/application/ports/provider/provider-repository";

export const createProviderStudio = createAsyncThunk<string, CreateProviderStudioBody, { extra: Partial<Dependencies> }>(
  "provider/studio/create",
  async (body, { extra: { providerRepository } }) => {
    return providerRepository!.createStudio(body);
  },
);

export const resetCreateProviderStudio = createAction("provider/studio/resetCreate");
